import React, { useEffect, useMemo, useRef, useState } from 'react';
import { NewModal } from '../../../../../ui/modals/new-modal';
import css from './modal.module.scss';
import { EditTemplateName } from './edit-template-name';
import { EditInConstructor } from './edit-in-constructor';
import { DownloadPrivatePdfButton } from './download-pdf-button';
import { ChangeableTagList } from '../../../../../../widgets/changeable-tag-bar/ui/tag-list/changeable-tag-list';
import { AddTagButton } from './add-tag';
import { IGetPrivateTemplateResponse } from '../../../../../../entities/template/private-template/api/types';
import { PrivateTemplateEditor } from '@start-set/wakadoo-editor-core';
import { IPrivateTemplateData } from '../../../../../../entities/template/types';
import IEditorStructure from '@start-set/wakadoo-editor-core/IEditorStructure';
import {
	useAdaptVisualizerEditor
} from '../../../../../../shared/libs/EditorManipulators/hooks/useAdaptVisualizerEditor';

interface ITemplateInfoModalProps {
	isActive: boolean,
	onClose: () => void,
	editName: (name: string) => Promise<void>,
	data: IGetPrivateTemplateResponse,
	unbindTag: (tag: number) => void,
	onDownloadPDF: (
		editor: PrivateTemplateEditor | null,
		template: IPrivateTemplateData,
	) => void,
	isPDFAvailable: boolean,
	isDeleteModalActive: boolean,
	isEditModalActive: boolean,
}

export const PrivateTemplateInfoModal = (props: ITemplateInfoModalProps) => {
	const {
		isActive,
		onClose,
		editName,
		unbindTag,
		data,
		onDownloadPDF,
		isPDFAvailable,
		isDeleteModalActive,
		isEditModalActive,
	} = props;
	const { template, rootComponent } = data;
	const { id, name, tags } = template;

	const initialStructure = useMemo(() => ({
		id: template.id,
		name: template.name,
		root: rootComponent
	}), [template, rootComponent]);

	const { editorContainerRef, editor } = useAdaptVisualizerEditor({
		initialStructure,
	});

	return (
		<NewModal
			styles={css.wrapper}
			active={isActive}
			closeFunc={onClose}
			modalInModalActive={isDeleteModalActive || isEditModalActive}
		>
			<div className={css.preview}>
				<div
					ref={editorContainerRef}
					className={`${css.editor} ${css.editorStructureVisualizer}`}
				/>
			</div>
			<div className={css.options}>
				<EditTemplateName editName={editName} name={name} />

				<div className={css.tags}>
					<p className={css.title}>Теги</p>
					{(!tags.fromTemplates || tags.fromTemplates.length === 0) ? (
						<p>Отсутствуют</p>
					) : (
						<ChangeableTagList
							deleteTag={unbindTag}
							activeTags={tags.fromTemplates}
							disabledTags={tags.fromModules}
						/>
					)}
					<AddTagButton template={data.template} />
				</div>

				<div className={css.buttons}>
					<EditInConstructor id={id} onClose={onClose} />
					<DownloadPrivatePdfButton
						onDownloadPDF={onDownloadPDF}
						isPDFAvailable={isPDFAvailable}
						editor={editor as PrivateTemplateEditor | null}
						template={template}
					/>
					{!isPDFAvailable && (
						<span className={css.unavailableText}>Недоступно в пробной версии</span>
					)}
				</div>
			</div>
		</NewModal>
	);
};
